<igx-grid #gridDetallePegado [data]="dataDetalle" [height]="'100%'" [width]="'100%'" [locale]="localGrid"
          [allowFiltering]="true" [filterMode]="'excelStyleFilter'" [moving]="true">
  <igx-grid-toolbar>
    <igx-grid-toolbar-title>
      <app-filtro-general #filtroGeneral descripcionLabel="{{ 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL' | translate}}"
                          (enterPalabra)="filterInput($event)" (limpiarPalabras)="clearInput()" />
    </igx-grid-toolbar-title>
    <igx-grid-toolbar-actions>
      <app-mas-opciones-grid [arrayDatosAVer]="[0, 1, 2, 6]"
                             (opcionSeleccionada)="onSelectionDropDown($event)" />
    </igx-grid-toolbar-actions>
  </igx-grid-toolbar>
  <igx-column field="Codigo" header="{{'GRIDS.DETALLE_PEGADO.COL_CODIGO' | translate}}" width="150px"
              [dataType]="'string'" [resizable]="true" [sortable]="true" />
  <igx-column field="Columna" header="{{'GRIDS.DETALLE_PEGADO.COL_COLUMNA' | translate}}" width="170px"
              [dataType]="'string'" [resizable]="true" [sortable]="true" />
  <igx-column field="Detalle" header="{{'GRIDS.DETALLE_PEGADO.COL_DETALLE' | translate}}" width="480px"
              [dataType]="'string'" [resizable]="true" [sortable]="true" />
</igx-grid>
